(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react';
import Container from 'react-bootstrap/Container';
import ScrollToTop from "../components/scroll-to-top";
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Helmet } from "react-helmet";
import ResultFloorplans from '../components/result-floorplans';

class Floorplans extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "Studios - Floor Plans"), /*#__PURE__*/React.createElement("meta", {
      name: "description",
      content: "FULLY RENOVATED APARTMENTS The District, Studios floorplans listed"
    })), /*#__PURE__*/React.createElement(ScrollToTop, null), /*#__PURE__*/React.createElement(Header, {
      mode: "nobg"
    }), /*#__PURE__*/React.createElement("div", {
      id: "content",
      className: "bypass-block-target",
      tabIndex: "-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "topbg",
      id: "apartments"
    }, /*#__PURE__*/React.createElement("div", {
      className: "captionbg"
    }, /*#__PURE__*/React.createElement("p", null, "FULLY RENOVATED STUDIOS"))), /*#__PURE__*/React.createElement(Container, {
      className: "content"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "h1 mb-5 biglinehd"
    }, /*#__PURE__*/React.createElement("span", null, "Studios - Floor Plans")), /*#__PURE__*/React.createElement(ResultFloorplans, {
      beds: "studio"
    }))), /*#__PURE__*/React.createElement(Footer, null));
  }

  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }

}

const _default = Floorplans;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Floorplans, "Floorplans", "/var/www/html/websites/thedistrictusc-com/src/frontend/pages/floorplans-studio.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/thedistrictusc-com/src/frontend/pages/floorplans-studio.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();